import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

import { CapacitorCalendar } from '@ebarooni/capacitor-calendar';
import { isInsideAppContainer } from '../others';
import { apiManageCaller } from '../vmApi/apiUtils';

// WORKS IN IOS; NEEDS TO BE TESTED IN ANDROID
export const openLinksInAppBrowser = async (url) => {
  console.log('Opening pdf in the app browser');

  if (!isInsideAppContainer()) {
    console.log('Browser is only available on native platforms.');
    return;
  }
  try {
    const { Browser } = Capacitor?.Plugins;
    await Browser.open({ url });

    if (App) {
      App.addListener('appUrlOpen', (data) => {
        const u = new URL(data.url);
        if (u.hostname === 'closePayment') {
          Browser.close();

          const { searchParams } = new URL(u);
          const redirectUrl = searchParams.get('redirectUrl');
          const redirect = new URL(redirectUrl);
          const baseUrl = `${redirect.origin}${redirect.pathname}`;
          const orderId = redirect.searchParams.get('orderId');
          const cleanUrl = `${baseUrl}?orderId=${orderId}`;

          window.location.href = cleanUrl;
        }


        if (u.hostname === 'close') {
          Browser.close();
        }
      });
    }
  } catch (error) {
    if (error instanceof Error) {
      console.log(`Error opening link in browser: ${error.message}`);
    } else {
      console.log('An unknown error occurred'); // Fallback for non-Error objects
    }
  }
};

export const closeInAppBrowser = async () => {
  if (!isInsideAppContainer()) {
    return;
  }
  try {
    const { Browser } = Capacitor?.Plugins;
    await Browser.close();
  } catch (error) {
    if (error instanceof Error) {
      console.log(`Error opening PDF in browser: ${error.message}`);
    } else {
      console.log('An unknown error occurred'); // Fallback for non-Error objects
    }
  }
};

export const handlePDFDownload = async () => {
  const pdf = await apiManageCaller({
    endpoint: '/api/Modules/DownloadPersonalProgram/',
    addToParams: { useEventId: true },
    returnDataAsIs: true
  });

  const buffer = await pdf.arrayBuffer();

  const blob = new Blob([buffer], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  window.open(url, '_self');
};

// export const openPdfInExternalBrowser = (url) => {
//   console.log('Opening link in the system browser');
//   window.open(url, '_system');
// };

// export const openLinkOutsideApp = (url) => {
//   console.log('Opening link outside the app');
//   window.open(url, '_system');
// };

// export const openLinkInsideAppWithoutBrowser = (url) => {
//   console.log('Opening link inside the app without a browser');
//   window.open(url, '_self');
// };

export const openCalendar = async (object) => {
  if (!isInsideAppContainer()) {
    alert('Calendar functionality is only available on native platforms.');
    return;
  }

  try {
    await CapacitorCalendar.requestFullCalendarAccess();

    await CapacitorCalendar.createEventWithPrompt({
      title: object.Text,
      location: object.RoomName,
      notes: '',
      startDate: new Date(object.StartDateTime).getTime(),
      endDate: new Date(object.EndDateTime).getTime(),
    });
  } catch (error) {
    console.error('Calendar error:', error);
    alert('Failed to create calendar event.');
  }
};

// WORKS IN IOS; NEEDS TO BE TESTED IN ANDROID

// // Utility to convert Blob to Base64
// const blobToBase64 = (blob) => new Promise((resolve, reject) => {
//   const reader = new FileReader();
//   reader.onloadend = () => {
//     const base64 = reader.result?.toString().split(',')[1];
//     if (base64) {
//       resolve(base64);
//     } else {
//       reject(new Error('Conversion failed'));
//     }
//   };
//   reader.onerror = reject;
//   reader.readAsDataURL(blob);
// });

// export const downloadPdfToFilesystem = async (url) => {
//   if (!isNative()) {
//     console.log('Filesystem is only available on native platforms.');
//     return;
//   }
//   try {
//     const Filesystem = Capacitor?.Plugins?.Filesystem;
//     if (!Filesystem) throw new Error('Capacitor Filesystem plugin not found.');

//     const targetUrl = url;
//     const response = await fetch(targetUrl);

//     if (!response.ok) {
//       throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
//     }

//     const blob = await response.blob();
//     const base64data = await blobToBase64(blob);

//     if (!base64data) {
//       throw new Error('Failed to convert PDF to Base64.');
//     }

//     const result = await Filesystem.writeFile({
//       path: 'myfile.pdf',
//       data: base64data,
//       directory: 'DOCUMENTS',
//     });

//     console.log('File saved to:', result.uri);
//     console.log('PDF downloaded to Filesystem');
//   } catch (error) {
//     if (error instanceof Error) {
//       console.log(`Error downloading PDF: ${error.message}`);
//     } else {
//       console.log('An unknown error occurred'); // Fallback for non-Error objects
//     }
//   }
// };
